export const countPolishCurrencySum = (orders, correctionNumberFilterRef) =>
	orders
		.filter((order) =>
			correctionNumberFilterRef.current?.checked
				? !!order._ticket?.invoice?.correction_number
				: true,
		)
		.reduce((prev, curr) => prev + curr.claim.polish_currency, 0)
		.toFixed(2);
